// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/HowItWorks.css */
.approach-ops {
  background: 
    radial-gradient(circle at 20% 20%, rgba(126, 211, 33, 0.15), transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(44, 62, 80, 0.12), transparent 50%),
    linear-gradient(180deg, #ffffff 0%, #f8fffe 50%, #ffffff 100%);
  padding: 80px 8vw;
  position: relative;
  z-index: 2;
  overflow: hidden;
}

.approach-ops::before {
  content: '';
  position: absolute;
  top: -100px;
  right: -100px;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(126, 211, 33, 0.12), transparent 60%);
  border-radius: 50%;
  animation: floatBlob 12s ease-in-out infinite;
}

.approach-ops::after {
  content: '';
  position: absolute;
  bottom: -150px;
  left: -150px;
  width: 700px;
  height: 700px;
  background: radial-gradient(circle, rgba(44, 62, 80, 0.08), transparent 60%);
  border-radius: 50%;
  animation: floatBlob 15s ease-in-out infinite reverse;
}

@keyframes floatBlob {
  0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
  33% { transform: translate(30px, -40px) scale(1.1) rotate(120deg); }
  66% { transform: translate(-40px, 30px) scale(0.95) rotate(240deg); }
}

.approach-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.approach-header {
  max-width: 700px;
  margin-bottom: 80px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.approach-tag {
  font-size: 12px;
  letter-spacing: 0.14em;
  font-weight: 700;
  color: #7ED321;
  text-transform: uppercase;
  display: inline-block;
  padding: 6px 16px;
  background: rgba(126, 211, 33, 0.12);
  border-radius: 999px;
  border: 1px solid rgba(126, 211, 33, 0.3);
  margin-bottom: 20px;
}

.approach-header h2 {
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #0f172a 0%, #2C3E50 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1.2;
}

.approach-header p {
  font-size: 18px;
  line-height: 1.7;
  color: #475569;
  max-width: 600px;
  margin: 0 auto;
}

.approach-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  align-items: start;
  position: relative;
}

.approach-steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px;
}

/* Animated flowing line */
.approach-steps::before {
  content: '';
  position: absolute;
  left: 29px;
  top: 60px;
  bottom: 60px;
  width: 3px;
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(126, 211, 33, 0.6) 10%,
    rgba(126, 211, 33, 0.8) 50%,
    rgba(44, 62, 80, 0.5) 90%,
    transparent
  );
  border-radius: 999px;
  box-shadow: 0 0 20px rgba(126, 211, 33, 0.4);
}

.step {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 24px;
  padding: 28px 32px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.92) 100%);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 2px solid rgba(126, 211, 33, 0.2);
  box-shadow: 0 10px 30px rgba(44, 62, 80, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  z-index: 1;
  will-change: transform, box-shadow;
  transform: translateZ(0);
}

.step::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(126, 211, 33, 0.12) 0%,
    rgba(126, 211, 33, 0.05) 50%,
    transparent 100%
  );
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: -1;
}

.step:hover::before {
  opacity: 1;
}

.step::after {
  content: '';
  position: absolute;
  inset: -2px;
  background: linear-gradient(135deg, #7ED321, #4ade80, #2C3E50);
  border-radius: 20px;
  opacity: 0;
  z-index: -1;
  transition: opacity 0.5s ease;
  filter: blur(10px);
}

.step:hover::after {
  opacity: 0.3;
}

.step:hover {
  transform: translateX(8px) translateY(-4px) scale(1.02);
  box-shadow: 0 25px 60px rgba(44, 62, 80, 0.15);
  border-color: rgba(126, 211, 33, 0.4);
  background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.96) 100%);
}

.step-num {
  font-size: 36px;
  font-weight: 800;
  color: #7ED321;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #7ED321 0%, #5AB015 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  border-radius: 50%;
  margin-top: 4px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1.4);
  border: 2px solid rgba(126, 211, 33, 0.3);
  background-color: rgba(126, 211, 33, 0.1);
  z-index: 2;
}

/* Pulsing ring on number */
.step-num::before {
  content: '';
  position: absolute;
  inset: -8px;
  border: 2px solid rgba(126, 211, 33, 0.3);
  border-radius: 50%;
  opacity: 0;
  transition: all 0.4s ease;
}

.step:hover .step-num::before {
  opacity: 0.4;
  inset: -12px;
}

.step:hover .step-num {
  background-color: rgba(126, 211, 33, 0.25);
  border-color: rgba(126, 211, 33, 0.7);
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 4px 15px rgba(126, 211, 33, 0.2);
}

.step h3 {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
  line-height: 1.3;
}

.step p {
  color: #475569;
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
}

.approach-image {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 30px 60px -10px rgba(44, 62, 80, 0.2);
  height: 100%;
  min-height: 500px;
}

.image-main {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}

.image-main img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  transform: translateZ(0);
}

.approach-image:hover .image-main img {
  transform: scale(1.05);
}

.floating-stats {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 30px;
  display: flex;
  gap: 15px;
  z-index: 2;
}

.stat-badge {
  background: rgba(255, 255, 255, 0.95);
  padding: 16px 20px;
  border-radius: 14px;
  text-align: center;
  flex: 1 1;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.stat-badge:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

.stat-badge strong {
  display: block;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 4px;
  line-height: 1;
}

.stat-badge span {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive styles */
@media (max-width: 1024px) {
  .approach-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }
  
  .approach-image {
    min-height: 400px;
  }
  
  .approach-header h2 {
    font-size: 36px;
  }
}

@media (max-width: 768px) {
  .approach-ops {
    padding: 60px 5vw;
  }

  /* Reduce heavy background animation on mobile/tablet for smoother scroll */
  .approach-ops::before,
  .approach-ops::after {
    display: none;
  }
  
  .approach-header h2 {
    font-size: 32px;
  }
  
  .approach-header p {
    font-size: 16px;
  }
  
  .step {
    padding: 20px;
    grid-template-columns: 50px 1fr;
    gap: 18px;
    box-shadow: 0 8px 20px rgba(44, 62, 80, 0.08);
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
  
  .step-num {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
  
  .step h3 {
    font-size: 18px;
  }
  
  .step p {
    font-size: 14px;
  }
  
  .floating-stats {
    left: 20px;
    right: 20px;
    bottom: 20px;
    flex-wrap: wrap;
  }
  
  .stat-badge {
    padding: 12px 15px;
  }
  
  .stat-badge strong {
    font-size: 18px;
  }
  
  .stat-badge span {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .approach-ops {
    padding: 60px 4vw;
  }

  .approach-header {
    margin-bottom: 50px;
  }

  .approach-tag {
    font-size: 11px;
    padding: 5px 12px;
    margin-bottom: 16px;
  }

  .approach-header h2 {
    font-size: 26px;
    margin-bottom: 16px;
  }

  .approach-header p {
    font-size: 15px;
  }

  .approach-steps {
    gap: 16px;
  }
  
  .approach-steps::before {
    left: 24px;
    top: 50px;
    bottom: 50px;
    width: 2px;
  }
  
  .step {
    padding: 16px;
    grid-template-columns: 48px 1fr;
    gap: 14px;
    border-radius: 16px;
  }

  .step-num {
    width: 48px;
    height: 48px;
    font-size: 22px;
  }

  .step h3 {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .step p {
    font-size: 13px;
    line-height: 1.6;
  }

  .approach-image {
    min-height: 350px;
  }
  
  .floating-stats {
    position: static;
    margin-top: 20px;
    gap: 10px;
  }
  
  .stat-badge {
    padding: 10px 12px;
  }

  .stat-badge strong {
    font-size: 16px;
  }

  .stat-badge span {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HowItWorks.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE;;;kEAGgE;EAChE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,8EAA8E;EAC9E,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,4EAA4E;EAC5E,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,WAAW,gDAAgD,EAAE;EAC7D,MAAM,2DAA2D,EAAE;EACnE,MAAM,4DAA4D,EAAE;AACtE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;EACpC,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV;;;;;;;GAOC;EACD,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,iGAAiG;EACjG,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,sFAAsF;EACtF,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;EACV,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,8DAA8D;EAC9D,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,8CAA8C;EAC9C,qCAAqC;EACrC,8FAA8F;AAChG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;EACvD,yCAAyC;EACzC,yCAAyC;EACzC,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mDAAmD;EACnD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uDAAuD;EACvD,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;EACP,2CAA2C;EAC3C,0CAA0C;EAC1C,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA,2EAA2E;EAC3E;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,6CAA6C;IAC7C,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* src/components/HowItWorks.css */\n.approach-ops {\n  background: \n    radial-gradient(circle at 20% 20%, rgba(126, 211, 33, 0.15), transparent 50%),\n    radial-gradient(circle at 80% 80%, rgba(44, 62, 80, 0.12), transparent 50%),\n    linear-gradient(180deg, #ffffff 0%, #f8fffe 50%, #ffffff 100%);\n  padding: 80px 8vw;\n  position: relative;\n  z-index: 2;\n  overflow: hidden;\n}\n\n.approach-ops::before {\n  content: '';\n  position: absolute;\n  top: -100px;\n  right: -100px;\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(circle, rgba(126, 211, 33, 0.12), transparent 60%);\n  border-radius: 50%;\n  animation: floatBlob 12s ease-in-out infinite;\n}\n\n.approach-ops::after {\n  content: '';\n  position: absolute;\n  bottom: -150px;\n  left: -150px;\n  width: 700px;\n  height: 700px;\n  background: radial-gradient(circle, rgba(44, 62, 80, 0.08), transparent 60%);\n  border-radius: 50%;\n  animation: floatBlob 15s ease-in-out infinite reverse;\n}\n\n@keyframes floatBlob {\n  0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }\n  33% { transform: translate(30px, -40px) scale(1.1) rotate(120deg); }\n  66% { transform: translate(-40px, 30px) scale(0.95) rotate(240deg); }\n}\n\n.approach-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n}\n\n.approach-header {\n  max-width: 700px;\n  margin-bottom: 80px;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.approach-tag {\n  font-size: 12px;\n  letter-spacing: 0.14em;\n  font-weight: 700;\n  color: #7ED321;\n  text-transform: uppercase;\n  display: inline-block;\n  padding: 6px 16px;\n  background: rgba(126, 211, 33, 0.12);\n  border-radius: 999px;\n  border: 1px solid rgba(126, 211, 33, 0.3);\n  margin-bottom: 20px;\n}\n\n.approach-header h2 {\n  font-size: 42px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  margin-bottom: 20px;\n  background: linear-gradient(135deg, #0f172a 0%, #2C3E50 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  line-height: 1.2;\n}\n\n.approach-header p {\n  font-size: 18px;\n  line-height: 1.7;\n  color: #475569;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.approach-grid {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 60px;\n  align-items: start;\n  position: relative;\n}\n\n.approach-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  position: relative;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n/* Animated flowing line */\n.approach-steps::before {\n  content: '';\n  position: absolute;\n  left: 29px;\n  top: 60px;\n  bottom: 60px;\n  width: 3px;\n  background: linear-gradient(\n    to bottom,\n    transparent,\n    rgba(126, 211, 33, 0.6) 10%,\n    rgba(126, 211, 33, 0.8) 50%,\n    rgba(44, 62, 80, 0.5) 90%,\n    transparent\n  );\n  border-radius: 999px;\n  box-shadow: 0 0 20px rgba(126, 211, 33, 0.4);\n}\n\n.step {\n  display: grid;\n  grid-template-columns: 60px 1fr;\n  gap: 24px;\n  padding: 28px 32px;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.92) 100%);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  border: 2px solid rgba(126, 211, 33, 0.2);\n  box-shadow: 0 10px 30px rgba(44, 62, 80, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.9);\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  will-change: transform, box-shadow;\n  transform: translateZ(0);\n}\n\n.step::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(126, 211, 33, 0.12) 0%,\n    rgba(126, 211, 33, 0.05) 50%,\n    transparent 100%\n  );\n  opacity: 0;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  z-index: -1;\n}\n\n.step:hover::before {\n  opacity: 1;\n}\n\n.step::after {\n  content: '';\n  position: absolute;\n  inset: -2px;\n  background: linear-gradient(135deg, #7ED321, #4ade80, #2C3E50);\n  border-radius: 20px;\n  opacity: 0;\n  z-index: -1;\n  transition: opacity 0.5s ease;\n  filter: blur(10px);\n}\n\n.step:hover::after {\n  opacity: 0.3;\n}\n\n.step:hover {\n  transform: translateX(8px) translateY(-4px) scale(1.02);\n  box-shadow: 0 25px 60px rgba(44, 62, 80, 0.15);\n  border-color: rgba(126, 211, 33, 0.4);\n  background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.96) 100%);\n}\n\n.step-num {\n  font-size: 36px;\n  font-weight: 800;\n  color: #7ED321;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #7ED321 0%, #5AB015 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  border-radius: 50%;\n  margin-top: 4px;\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1.4);\n  border: 2px solid rgba(126, 211, 33, 0.3);\n  background-color: rgba(126, 211, 33, 0.1);\n  z-index: 2;\n}\n\n/* Pulsing ring on number */\n.step-num::before {\n  content: '';\n  position: absolute;\n  inset: -8px;\n  border: 2px solid rgba(126, 211, 33, 0.3);\n  border-radius: 50%;\n  opacity: 0;\n  transition: all 0.4s ease;\n}\n\n.step:hover .step-num::before {\n  opacity: 0.4;\n  inset: -12px;\n}\n\n.step:hover .step-num {\n  background-color: rgba(126, 211, 33, 0.25);\n  border-color: rgba(126, 211, 33, 0.7);\n  transform: scale(1.1) rotate(5deg);\n  box-shadow: 0 4px 15px rgba(126, 211, 33, 0.2);\n}\n\n.step h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 10px;\n  line-height: 1.3;\n}\n\n.step p {\n  color: #475569;\n  font-size: 15px;\n  line-height: 1.7;\n  margin: 0;\n}\n\n.approach-image {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 30px 60px -10px rgba(44, 62, 80, 0.2);\n  height: 100%;\n  min-height: 500px;\n}\n\n.image-main {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.image-main img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n  transform: translateZ(0);\n}\n\n.approach-image:hover .image-main img {\n  transform: scale(1.05);\n}\n\n.floating-stats {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n  right: 30px;\n  display: flex;\n  gap: 15px;\n  z-index: 2;\n}\n\n.stat-badge {\n  background: rgba(255, 255, 255, 0.95);\n  padding: 16px 20px;\n  border-radius: 14px;\n  text-align: center;\n  flex: 1;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n}\n\n.stat-badge:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);\n}\n\n.stat-badge strong {\n  display: block;\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 4px;\n  line-height: 1;\n}\n\n.stat-badge span {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Responsive styles */\n@media (max-width: 1024px) {\n  .approach-grid {\n    grid-template-columns: 1fr;\n    gap: 50px;\n  }\n  \n  .approach-image {\n    min-height: 400px;\n  }\n  \n  .approach-header h2 {\n    font-size: 36px;\n  }\n}\n\n@media (max-width: 768px) {\n  .approach-ops {\n    padding: 60px 5vw;\n  }\n\n  /* Reduce heavy background animation on mobile/tablet for smoother scroll */\n  .approach-ops::before,\n  .approach-ops::after {\n    display: none;\n  }\n  \n  .approach-header h2 {\n    font-size: 32px;\n  }\n  \n  .approach-header p {\n    font-size: 16px;\n  }\n  \n  .step {\n    padding: 20px;\n    grid-template-columns: 50px 1fr;\n    gap: 18px;\n    box-shadow: 0 8px 20px rgba(44, 62, 80, 0.08);\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n  }\n  \n  .step-num {\n    width: 50px;\n    height: 50px;\n    font-size: 24px;\n  }\n  \n  .step h3 {\n    font-size: 18px;\n  }\n  \n  .step p {\n    font-size: 14px;\n  }\n  \n  .floating-stats {\n    left: 20px;\n    right: 20px;\n    bottom: 20px;\n    flex-wrap: wrap;\n  }\n  \n  .stat-badge {\n    padding: 12px 15px;\n  }\n  \n  .stat-badge strong {\n    font-size: 18px;\n  }\n  \n  .stat-badge span {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .approach-ops {\n    padding: 60px 4vw;\n  }\n\n  .approach-header {\n    margin-bottom: 50px;\n  }\n\n  .approach-tag {\n    font-size: 11px;\n    padding: 5px 12px;\n    margin-bottom: 16px;\n  }\n\n  .approach-header h2 {\n    font-size: 26px;\n    margin-bottom: 16px;\n  }\n\n  .approach-header p {\n    font-size: 15px;\n  }\n\n  .approach-steps {\n    gap: 16px;\n  }\n  \n  .approach-steps::before {\n    left: 24px;\n    top: 50px;\n    bottom: 50px;\n    width: 2px;\n  }\n  \n  .step {\n    padding: 16px;\n    grid-template-columns: 48px 1fr;\n    gap: 14px;\n    border-radius: 16px;\n  }\n\n  .step-num {\n    width: 48px;\n    height: 48px;\n    font-size: 22px;\n  }\n\n  .step h3 {\n    font-size: 16px;\n    margin-bottom: 8px;\n  }\n\n  .step p {\n    font-size: 13px;\n    line-height: 1.6;\n  }\n\n  .approach-image {\n    min-height: 350px;\n  }\n  \n  .floating-stats {\n    position: static;\n    margin-top: 20px;\n    gap: 10px;\n  }\n  \n  .stat-badge {\n    padding: 10px 12px;\n  }\n\n  .stat-badge strong {\n    font-size: 16px;\n  }\n\n  .stat-badge span {\n    font-size: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
